module.exports = __webpack_public_path__ + "media/media/home/img5-a2ea452f461be7ef05983e7a3ee3140f.png";